export default __webpack_public_path__ + "static/media/Background_00087.8e09b7fb.png";